import React, { useState } from "react";

export default function NuvaiWebsite() {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className={`min-h-screen font-sans transition-colors duration-300 ${darkMode ? "bg-[#1a1a1a] text-white" : "bg-[#fdf7f2] text-[#3b3b3b]"}`}>
      <header className={`p-6 flex justify-between items-center shadow-md ${darkMode ? "bg-[#2b2b2b]" : "bg-white"}`}>
        <a href="#" className="flex items-center gap-4">
  <img
    src={darkMode ? "/images/logo-dark.png" : "/images/logo.png"}
    alt="NUVAI Logo"
    className="h-20 sm:h-24 md:h-28 lg:h-32 object-contain"
  />
  <span className="text-3xl font-bold text-gold font-serif">NUVAI</span>
</a>
        <nav className="space-x-6 font-sans">
          <a href="#shop" className="hover:text-gold">Shop</a>
          <a href="#about" className="hover:text-gold">About</a>
          <a href="#contact" className="hover:text-gold">Contact</a>
        </nav>
        <button
          onClick={() => setDarkMode(!darkMode)}
          className="ml-4 text-sm px-4 py-2 rounded-full border border-gold text-gold hover:bg-gold hover:text-white"
        >
          {darkMode ? "☀ Light Mode" : "🌙 Dark Mode"}
        </button>
      </header>

      <section className={`${darkMode ? "bg-[#2b2b2b]" : "bg-white"} text-center py-20 px-6`}>
        <h2 className="text-4xl font-semibold mb-4 text-gold font-serif">Empower Your Every Move</h2>
        <p className="max-w-xl mx-auto text-lg">
          Luxury activewear and lingerie, designed and made in Colombia. Created for women who move with confidence, power, and grace.
        </p>
        <button className="mt-6 bg-gold text-white py-2 px-6 rounded-full hover:bg-gold-dark font-sans">
          Shop Now
        </button>
      </section>

      <section id="shop" className="py-20 px-6">
        <h3 className="text-3xl font-semibold text-center text-gold font-serif mb-10">Our Collection</h3>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className={`${darkMode ? "bg-[#2b2b2b]" : "bg-white"} rounded shadow p-4`}>
            <img src="/images/set1.jpg" alt="Beige Set" className="rounded mb-4" />
            <h4 className="font-semibold text-lg">Beige Activewear Set</h4>
            <p className="text-sm">Soft, breathable, and elegant.</p>
          </div>
          <div className={`${darkMode ? "bg-[#2b2b2b]" : "bg-white"} rounded shadow p-4`}>
            <img src="/images/lingerie1.jpg" alt="Lingerie Set" className="rounded mb-4" />
            <h4 className="font-semibold text-lg">Luxe Lingerie Set</h4>
            <p className="text-sm">Confidence and comfort in every detail.</p>
          </div>
          <div className={`${darkMode ? "bg-[#2b2b2b]" : "bg-white"} rounded shadow p-4`}>
            <img src="/images/black_set.jpg" alt="Black Set" className="rounded mb-4" />
            <h4 className="font-semibold text-lg">Black Sculpt Set</h4>
            <p className="text-sm">Supportive and stylish for every move.</p>
          </div>
        </div>
      </section>

      <section id="reviews" className={`py-20 px-6 ${darkMode ? "bg-[#1a1a1a]" : "bg-white"}`}>
        <h3 className="text-3xl font-semibold text-center text-gold font-serif mb-10">Customer Reviews</h3>
        <div className="max-w-3xl mx-auto space-y-6">
          {["Absolutely love the fit and feel. The fabric is so soft and empowering!", "The lingerie set makes me feel confident and elegant. Perfect for every day.", "The quality is amazing and I feel empowered every time I wear it!"].map((text, i) => (
            <div key={i} className={`${darkMode ? "bg-[#2b2b2b]" : "bg-[#fdf7f2]"} p-6 rounded shadow`}>
              <p className="italic text-lg">“{text}”</p>
              <p className="mt-4 text-sm text-right text-neutral-600">— Customer</p>
            </div>
          ))}
        </div>
        <div className="mt-10 text-center">
          <a
            href="https://www.instagram.com/stories/highlights/1234567890/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-gold hover:underline text-lg"
          >
            → See more reviews on Instagram Highlights
          </a>
        </div>
      </section>

      <section id="contact" className={`py-20 px-6 ${darkMode ? "bg-[#1a1a1a]" : "bg-[#fdf7f2]"}`}>
        <h3 className="text-3xl font-semibold text-center text-gold font-serif mb-6">Contact Us</h3>
        <form className="max-w-xl mx-auto space-y-4">
          <input type="text" placeholder="Your Name" className="w-full p-3 border border-gray-300 rounded" />
          <input type="email" placeholder="Your Email" className="w-full p-3 border border-gray-300 rounded" />
          <textarea placeholder="Your Message" className="w-full p-3 border border-gray-300 rounded h-32"></textarea>
          <button type="submit" className="bg-gold text-white py-2 px-6 rounded-full hover:bg-gold-dark">
            Send Message
          </button>
        </form>
      </section>

      <footer className={`py-6 text-center text-sm ${darkMode ? "bg-[#2b2b2b] text-neutral-400" : "bg-white text-neutral-500"}`}>
        © {new Date().getFullYear()} NUVAI. All rights reserved. | Follow us on <a href="https://instagram.com/NUVAISHOP" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline">Instagram</a>
      </footer>
    </div>
  );
}
